import React from "react";
import { withFormsy } from "formsy-react";

import connect from "../../../i18n/connect";
import Radio from "../../../web/components/landingPage/pages/Notifications/components/radio/Radio";
import FormsyBase from "./FormsyBase";

import "./FormsyComposedNewRadioGroup.scss";

@connect()
@withFormsy
class FormsyComposedNewRadioGroup extends FormsyBase {
  isOptionChecked(option) {
    const { value, options } = this.props;

    if (value !== undefined && value !== null) {
      return value === option;
    }

    if (options && options.includes("all")) {
      return option === "all";
    }

    return false;
  }

  selectOption(option) {
    const next = option === "all" ? null : option;
    this.handleChange(next);
  }

  render() {
    const {
      name,
      label,
      options,
      errorMessage,
      translate,
      disabled
    } = this.props;

    const showError = this.showError();
    const list = options || [];

    return (
      <div className="formsy-composed-new-radio-group">
        <div className="formsy-composed-new-radio-group_label">{translate(label)}</div>
        <div
          className="formsy-composed-new-radio-group_options"
          role="radiogroup"
          aria-label={translate(label)}
        >
          {list.map(option => (
            <Radio
              key={String(option)}
              id={`${name}-${String(option)}`}
              name={name}
              label={translate(String(option))}
              checked={this.isOptionChecked(option)}
              disabled={disabled}
              onChange={() => {
                if (!disabled) {
                  this.selectOption(option);
                }
              }}
            />
          ))}
        </div>
        {showError && errorMessage ? (
          <span className="formsy-composed-new-radio-group_error">
            {translate(errorMessage)}
          </span>
        ) : null}
      </div>
    );
  }
}

export default FormsyComposedNewRadioGroup;
